import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import styles from "./TabSectionCommon.module.css";
import { FlexContainer, MainContainer } from "../assets/styles/theme/styles";
import Heading from "./Heading";
import Paragraph from "./Paragraph";

export default function TabSectionCommon({ heading, codeSnippets }) {
  const [activeTab, setActiveTab] = useState(0);

  const customStyle = {
    maxHeight: "313px",
    overflowY: "overlay",
  };

  const codeTagProps = {
    style: {
      fontSize: "16px",
    },
  };

  return (
    <MainContainer>
      <div className={styles.framer_container}>
        {heading && (
          <Heading level={1} style={{ marginBottom: "3rem" }}>
            {heading}
          </Heading>
        )}

        <Tabs
          selectedIndex={activeTab}
          onSelect={(index) => setActiveTab(index)}
          selectedTabClassName={styles.selected_tab}
        >
          <TabList className={styles.tablist}>
            {codeSnippets.map((ele, ind) => {
              return <Tab className={styles.tab}>{ele.language}</Tab>;
            })}
          </TabList>
          <div className={styles.tab__content}>
            {codeSnippets.map((snippet, index) => (
              <TabPanel key={index}>
                <FlexContainer gap="4rem" flex="1">
                  <div>
                    <Heading level={2} color="black">
                      {" "}
                      {snippet.contentHead}
                    </Heading>
                  </div>
                  <div>
                    <Paragraph level={3}>{snippet.contentPara}</Paragraph>
                  </div>
                </FlexContainer>
              </TabPanel>
            ))}
          </div>
        </Tabs>
      </div>
    </MainContainer>
  );
}
